import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-100/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link
            to="/"
            className="flex items-center gap-2 group"
          >
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-movie-2-fill text-lg text-white"></i>
            </div>
            <span className="text-xl font-bold text-foreground-50 font-heading tracking-wide whitespace-nowrap">
              大师兄影视
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm rounded-lg transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? 'bg-primary-500/20 text-primary-300'
                  : 'text-foreground-300 hover:text-foreground-100 hover:bg-background-200/60'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 text-sm rounded-lg transition-colors whitespace-nowrap ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-500/20 text-primary-300'
                    : 'text-foreground-300 hover:text-foreground-100 hover:bg-background-200/60'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 text-sm rounded-lg transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'bg-primary-500/20 text-primary-300'
                  : 'text-foreground-300 hover:text-foreground-100 hover:bg-background-200/60'
              }`}
            >
              关于我们
            </Link>
          </div>

          {/* Search + Actions */}
          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索影片..."
                className="w-48 lg:w-56 bg-background-200/60 border border-background-300/40 rounded-full px-4 py-2 pl-10 text-sm text-foreground-200 placeholder-foreground-500 focus:outline-none focus:border-primary-500/50 focus:bg-background-200 transition-all"
              />
              <i className="ri-search-line absolute left-3.5 top-1/2 -translate-y-1/2 text-foreground-500 text-sm"></i>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-300 hover:text-foreground-100 hover:bg-background-200/60 transition-colors"
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden border-t border-background-200/40 py-3">
            <div className="flex flex-col gap-1">
              <Link
                to="/"
                onClick={() => setIsMobileMenuOpen(false)}
                className="px-4 py-2.5 text-sm rounded-lg text-foreground-300 hover:text-foreground-100 hover:bg-background-200/60 transition-colors"
              >
                首页
              </Link>
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="px-4 py-2.5 text-sm rounded-lg text-foreground-300 hover:text-foreground-100 hover:bg-background-200/60 transition-colors"
                >
                  {cat.name}
                </Link>
              ))}
              <Link
                to="/about"
                onClick={() => setIsMobileMenuOpen(false)}
                className="px-4 py-2.5 text-sm rounded-lg text-foreground-300 hover:text-foreground-100 hover:bg-background-200/60 transition-colors"
              >
                关于我们
              </Link>
              <div className="px-4 pt-2">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="搜索影片..."
                    className="w-full bg-background-200/60 border border-background-300/40 rounded-full px-4 py-2.5 pl-10 text-sm text-foreground-200 placeholder-foreground-500 focus:outline-none focus:border-primary-500/50 transition-all"
                  />
                  <i className="ri-search-line absolute left-3.5 top-1/2 -translate-y-1/2 text-foreground-500 text-sm"></i>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}